import { render, staticRenderFns } from "./RecentLocationSummary.vue?vue&type=template&id=711dd75a&scoped=true&"
import script from "./RecentLocationSummary.vue?vue&type=script&lang=js&"
export * from "./RecentLocationSummary.vue?vue&type=script&lang=js&"
import style0 from "./RecentLocationSummary.vue?vue&type=style&index=0&id=711dd75a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711dd75a",
  null
  
)

export default component.exports